export enum ErrorBannerTypes {
  SET_ERROR_BANNER_MESSAGE = 'SET_ERROR_BANNER_MESSAGE',
  SET_ERROR_BANNER_MESSAGE__CLEAR = 'SET_ERROR_BANNER_MESSAGE__CLEAR',
}
